module.exports = "/images/side-support-active.svg?1e400109ba68c04421565df5d3ddfed4";